export const GET_PROJECT_ALL_BRANDS_RESPONSE = 'get-project-all-brands-response';
export const GET_PROJECT_DAILY_STATS = 'get-project-daily-stats';
export const GET_PROJECT_VISIBILITY_CHART = 'get-project-visibility-chart';
export const GET_PROJECT_SOV_TIME_SERIES = 'get-project-sov-time-series';
export const GET_PROJECT_VISIBILITY_PER_MONITOR = 'get-project-visibility-per-monitor';
